export default "__VITE_ASSET__DywK7$qJ__"